module.exports = __webpack_public_path__ + "dlssrvtyy/img/share-thai.jpg?0d24957e";